import React from "react";

import type { RouterOutputs } from "~/utils/api";

interface ResultsContext {
  tasksStatus: RouterOutputs["home"]["tasksStatus"];
}

export const ResultsContext = React.createContext<ResultsContext>(null!);

export const useResultsContext = () => {
  const context = React.useContext(ResultsContext);
  if (!context) {
    throw new Error(
      "useResultsContext must be used within a ResultsContext.Provider",
    );
  }
  return context;
};
